export const GET_CAPEX_RELATED_BUDGET_INIT = "GET_CAPEX_RELATED_BUDGET_INIT";
export const GET_CAPEX_RELATED_BUDGET_SUCCESS =
  "GET_CAPEX_RELATED_BUDGET_SUCCESS";
export const GET_CAPEX_RELATED_BUDGET_FAILED =
  "GET_CAPEX_RELATED_BUDGET_FAILED";
export const GET_CAPEX_RELATED_FORECAST_INIT =
  "GET_CAPEX_RELATED_FORECAST_INIT";
export const GET_CAPEX_RELATED_FORECAST_SUCCESS =
  "GET_CAPEX_RELATED_FORECAST_SUCCESS";
export const GET_CAPEX_RELATED_FORECAST_FAILED =
  "GET_CAPEX_RELATED_FORECAST_FAILED";
export const GET_DIRECT_EMPLOYEE_BUDGET_INIT =
  "GET_DIRECT_EMPLOYEE_BUDGET_INIT";
export const GET_DIRECT_EMPLOYEE_BUDGET_SUCCESS =
  "GET_DIRECT_EMPLOYEE_BUDGET_SUCCESS";
export const GET_DIRECT_EMPLOYEE_BUDGET_FAILED =
  "GET_DIRECT_EMPLOYEE_BUDGET_FAILED";
export const GET_DIRECT_EMPLOYEE_FORECAST_INIT =
  "GET_DIRECT_EMPLOYEE_FORECAST_INIT";
export const GET_DIRECT_EMPLOYEE_FORECAST_SUCCESS =
  "GET_DIRECT_EMPLOYEE_FORECAST_SUCCESS";
export const GET_DIRECT_EMPLOYEE_FORECAST_FAILED =
  "GET_DIRECT_EMPLOYEE_FORECAST_FAILED";
export const GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT =
  "GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT";
export const GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS =
  "GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS";
export const GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED =
  "GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED";
export const GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT =
  "GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT";
export const GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS =
  "GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS";
export const GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED =
  "GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED";
export const GET_VENDOR_EMPLOYEE_BUDGET_INIT =
  "GET_VENDOR_EMPLOYEE_BUDGET_INIT";
export const GET_VENDOR_EMPLOYEE_BUDGET_SUCCESS =
  "GET_VENDOR_EMPLOYEE_BUDGET_SUCCESS";
export const GET_VENDOR_EMPLOYEE_BUDGET_FAILED =
  "GET_VENDOR_EMPLOYEE_BUDGET_FAILED";
export const GET_VENDOR_EMPLOYEE_FORECAST_INIT =
  "GET_VENDOR_EMPLOYEE_FORECAST_INIT";
export const GET_VENDOR_EMPLOYEE_FORECAST_SUCCESS =
  "GET_VENDOR_EMPLOYEE_FORECAST_SUCCESS";
export const GET_VENDOR_EMPLOYEE_FORECAST_FAILED =
  "GET_VENDOR_EMPLOYEE_FORECAST_FAILED";
export const GET_VENDOR_RELATED_COST_BUDGET_INIT =
  "GET_VENDOR_RELATED_COST_BUDGET_INIT";
export const GET_VENDOR_RELATED_COST_BUDGET_SUCCESS =
  "GET_VENDOR_RELATED_COST_BUDGET_SUCCESS";
export const GET_VENDOR_RELATED_COST_BUDGET_FAILED =
  "GET_VENDOR_RELATED_COST_BUDGET_FAILED";
export const GET_VENDOR_RELATED_COST_FORECAST_INIT =
  "GET_VENDOR_RELATED_COST_FORECAST_INIT";
export const GET_VENDOR_RELATED_COST_FORECAST_SUCCESS =
  "GET_VENDOR_RELATED_COST_FORECAST_SUCCESS";
export const GET_VENDOR_RELATED_COST_FORECAST_FAILED =
  "GET_VENDOR_RELATED_COST_FORECAST_FAILED";
export const UPDATE_CAPEX_RELATED_BUDGET_INIT =
  "UPDATE_CAPEX_RELATED_BUDGET_INIT";
export const UPDATE_CAPEX_RELATED_BUDGET_SUCCESS =
  "UPDATE_CAPEX_RELATED_BUDGET_SUCCESS";
export const UPDATE_CAPEX_RELATED_BUDGET_FAILED =
  "UPDATE_CAPEX_RELATED_BUDGET_FAILED";
export const UPDATE_CAPEX_RELATED_FORECAST_INIT =
  "UPDATE_CAPEX_RELATED_FORECAST_INIT";
export const UPDATE_CAPEX_RELATED_FORECAST_SUCCESS =
  "UPDATE_CAPEX_RELATED_FORECAST_SUCCESS";
export const UPDATE_CAPEX_RELATED_FORECAST_FAILED =
  "UPDATE_CAPEX_RELATED_FORECAST_FAILED";
export const UPDATE_DIRECT_EMPLOYEE_BUDGET_INIT =
  "UPDATE_DIRECT_EMPLOYEE_BUDGET_INIT";
export const UPDATE_DIRECT_EMPLOYEE_BUDGET_SUCCESS =
  "UPDATE_DIRECT_EMPLOYEE_BUDGET_SUCCESS";
export const UPDATE_DIRECT_EMPLOYEE_BUDGET_FAILED =
  "UPDATE_DIRECT_EMPLOYEE_BUDGET_FAILED";
export const UPDATE_DIRECT_EMPLOYEE_FORECAST_INIT =
  "UPDATE_DIRECT_EMPLOYEE_FORECAST_INIT";
export const UPDATE_DIRECT_EMPLOYEE_FORECAST_SUCCESS =
  "UPDATE_DIRECT_EMPLOYEE_FORECAST_SUCCESS";
export const UPDATE_DIRECT_EMPLOYEE_FORECAST_FAILED =
  "UPDATE_DIRECT_EMPLOYEE_FORECAST_FAILED";
export const UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT =
  "UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT";
export const UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS =
  "UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS";
export const UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED =
  "UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED";
export const UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT =
  "UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT";
export const UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS =
  "UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS";
export const UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED =
  "UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED";
export const UPDATE_VENDOR_EMPLOYEE_BUDGET_INIT =
  "UPDATE_VENDOR_EMPLOYEE_BUDGET_INIT";
export const UPDATE_VENDOR_EMPLOYEE_BUDGET_SUCCESS =
  "UPDATE_VENDOR_EMPLOYEE_BUDGET_SUCCESS";
export const UPDATE_VENDOR_EMPLOYEE_BUDGET_FAILED =
  "UPDATE_VENDOR_EMPLOYEE_BUDGET_FAILED";
export const UPDATE_VENDOR_EMPLOYEE_FORECAST_INIT =
  "UPDATE_VENDOR_EMPLOYEE_FORECAST_INIT";
export const UPDATE_VENDOR_EMPLOYEE_FORECAST_SUCCESS =
  "UPDATE_VENDOR_EMPLOYEE_FORECAST_SUCCESS";
export const UPDATE_VENDOR_EMPLOYEE_FORECAST_FAILED =
  "UPDATE_VENDOR_EMPLOYEE_FORECAST_FAILED";
export const UPDATE_VENDOR_RELATED_COST_BUDGET_INIT =
  "UPDATE_VENDOR_RELATED_COST_BUDGET_INIT";
export const UPDATE_VENDOR_RELATED_COST_BUDGET_SUCCESS =
  "UPDATE_VENDOR_RELATED_COST_BUDGET_SUCCESS";
export const UPDATE_VENDOR_RELATED_COST_BUDGET_FAILED =
  "UPDATE_VENDOR_RELATED_COST_BUDGET_FAILED";
export const UPDATE_VENDOR_RELATED_COST_FORECAST_INIT =
  "UPDATE_VENDOR_RELATED_COST_FORECAST_INIT";
export const UPDATE_VENDOR_RELATED_COST_FORECAST_SUCCESS =
  "UPDATE_VENDOR_RELATED_COST_FORECAST_SUCCESS";
export const UPDATE_VENDOR_RELATED_COST_FORECAST_FAILED =
  "UPDATE_VENDOR_RELATED_COST_FORECAST_FAILED";
export const GET_FINANCIAL_SUMMARY_BUDGET_INIT =
  "GET_FINANCIAL_SUMMARY_BUDGET_INIT";
export const GET_FINANCIAL_SUMMARY_BUDGET_SUCCESS =
  "GET_FINANCIAL_SUMMARY_BUDGET_SUCCESS";
export const GET_FINANCIAL_SUMMARY_BUDGET_FAILED =
  "GET_FINANCIAL_SUMMARY_BUDGET_FAILED";
export const GET_INTERNAL_LABOR_SUMMARY_FORECAST_INIT =
  "GET_INTERNAL_LABOR_SUMMARY_FORECAST_INIT";
export const GET_INTERNAL_LABOR_SUMMARY_FORECAST_SUCCESS =
  "GET_INTERNAL_LABOR_SUMMARY_FORECAST_SUCCESS";
export const GET_INTERNAL_LABOR_SUMMARY_FORECAST_FAILED =
  "GET_INTERNAL_LABOR_SUMMARY_FORECAST_FAILED";
export const GET_TOTAL_CAPEX_SUMMARY_BUDGET_INIT =
  "GET_TOTAL_CAPEX_SUMMARY_BUDGET_INIT";
export const GET_TOTAL_CAPEX_SUMMARY_BUDGET_SUCCESS =
  "GET_TOTAL_CAPEX_SUMMARY_BUDGET_SUCCESS";
export const GET_TOTAL_CAPEX_SUMMARY_BUDGET_FAILED =
  "GET_TOTAL_CAPEX_SUMMARY_BUDGET_FAILED";
export const GET_FINANCIAL_SUMMARY_FORECAST_INIT =
  "GET_FINANCIAL_SUMMARY_FORECAST_INIT";
export const GET_FINANCIAL_SUMMARY_FORECAST_SUCCESS =
  "GET_FINANCIAL_SUMMARY_FORECAST_SUCCESS";
export const GET_FINANCIAL_SUMMARY_FORECAST_FAILED =
  "GET_FINANCIAL_SUMMARY_FORECAST_FAILED";
export const GET_VENDOR_LABOR_SUMMARY_BUDGET_INIT =
  "GET_VENDOR_LABOR_SUMMARY_BUDGET_INIT";
export const GET_VENDOR_LABOR_SUMMARY_BUDGET_SUCCESS =
  "GET_VENDOR_LABOR_SUMMARY_BUDGET_SUCCESS";
export const GET_VENDOR_LABOR_SUMMARY_BUDGET_FAILED =
  "GET_VENDOR_LABOR_SUMMARY_BUDGET_FAILED";
export const GET_VENDOR_LABOR_SUMMARY_FORECAST_INIT =
  "GET_VENDOR_LABOR_SUMMARY_FORECAST_INIT";
export const GET_VENDOR_LABOR_SUMMARY_FORECAST_SUCCESS =
  "GET_VENDOR_LABOR_SUMMARY_FORECAST_SUCCESS";
export const GET_VENDOR_LABOR_SUMMARY_FORECAST_FAILED =
  "GET_VENDOR_LABOR_SUMMARY_FORECAST_FAILED";
export const GET_TOP_PROJECT_VARIANCE_LIST_INIT =
  "GET_TOP_PROJECT_VARIANCE_LIST_INIT";
export const GET_TOP_PROJECT_VARIANCE_LIST_SUCCESS =
  "GET_TOP_PROJECT_VARIANCE_LIST_SUCCESS";
export const GET_TOP_PROJECT_VARIANCE_LIST_FAILED =
  "GET_TOP_PROJECT_VARIANCE_LIST_FAILED";
export const GET_BUDGET_VS_FORECAST_INIT = "GET_BUDGET_VS_FORECAST_INIT";
export const GET_BUDGET_VS_FORECAST_SUCCESS = "GET_BUDGET_VS_FORECAST_SUCCESS";
export const GET_BUDGET_VS_FORECAST_FAILED = "GET_BUDGET_VS_FORECAST_FAILED";
export const GET_PROJECT_VARIANCES_COST_WATERFALL_INIT =
  "GET_PROJECT_VARIANCES_COST_WATERFALL_INIT";
export const GET_PROJECT_VARIANCES_COST_WATERFALL_SUCCESS =
  "GET_PROJECT_VARIANCES_COST_WATERFALL_SUCCESS";
export const GET_PROJECT_VARIANCES_COST_WATERFALL_FAILED =
  "GET_PROJECT_VARIANCES_COST_WATERFALL_FAILED";
export const GET_UPCOMING_DEADLINES_INIT = "GET_UPCOMING_DEADLINES_INIT";
export const GET_UPCOMING_DEADLINES_SUCCESS = "GET_UPCOMING_DEADLINES_SUCCESS";
export const GET_UPCOMING_DEADLINES_FAILED = "GET_UPCOMING_DEADLINES_FAILED";
export const GET_CONTRACT_SUMMARY_INIT = "GET_CONTRACT_SUMMARY_INIT";
export const GET_CONTRACT_SUMMARY_SUCCESS = "GET_CONTRACT_SUMMARY_SUCCESS";
export const GET_CONTRACT_SUMMARY_FAILED = "GET_CONTRACT_SUMMARY_FAILED";
export const GET_CONTRACT_SUMMARY_COST_PLUS_INIT =
  "GET_CONTRACT_SUMMARY_COST_PLUS_INIT";
export const GET_CONTRACT_SUMMARY_COST_PLUS_SUCCESS =
  "GET_CONTRACT_SUMMARY_COST_PLUS_SUCCESS";
export const GET_CONTRACT_SUMMARY_COST_PLUS_FAILED =
  "GET_CONTRACT_SUMMARY_COST_PLUS_FAILED";
export const GET_CONTRACT_SUMMARY_EAC_INIT = "GET_CONTRACT_SUMMARY_EAC_INIT";
export const GET_CONTRACT_SUMMARY_EAC_SUCCESS =
  "GET_CONTRACT_SUMMARY_EAC_SUCCESS";
export const GET_CONTRACT_SUMMARY_EAC_FAILED =
  "GET_CONTRACT_SUMMARY_EAC_FAILED";
export const GET_DIRECT_LABOR_DETAILS_INIT = "GET_DIRECT_LABOR_DETAILS_INIT";
export const GET_DIRECT_LABOR_DETAILS_SUCCESS =
  "GET_DIRECT_LABOR_DETAILS_SUCCESS";
export const GET_DIRECT_LABOR_DETAILS_FAILED =
  "GET_DIRECT_LABOR_DETAILS_FAILED";
export const GET_OTHER_DIRECT_COSTS_INIT = "GET_OTHER_DIRECT_COSTS_INIT";
export const GET_OTHER_DIRECT_COSTS_SUCCESS = "GET_OTHER_DIRECT_COSTS_SUCCESS";
export const GET_OTHER_DIRECT_COSTS_FAILED = "GET_OTHER_DIRECT_COSTS_FAILED";
export const GET_REVENUE_INIT = "GET_REVENUE_INIT";
export const GET_REVENUE_SUCCESS = "GET_REVENUE_SUCCESS";
export const GET_REVENUE_FAILED = "GET_REVENUE_FAILED";
export const GET_MARGIN_INIT = "GET_MARGIN_INIT";
export const GET_MARGIN_SUCCESS = "GET_MARGIN_SUCCESS";
export const GET_MARGIN_FAILED = "GET_MARGIN_FAILED";
export const UPDATE_DIRECT_LABOR_DETAILS_INIT =
  "UPDATE_DIRECT_LABOR_DETAILS_INIT";
export const UPDATE_DIRECT_LABOR_DETAILS_SUCCESS =
  "UPDATE_DIRECT_LABOR_DETAILS_SUCCESS";
export const UPDATE_DIRECT_LABOR_DETAILS_FAILED =
  "UPDATE_DIRECT_LABOR_DETAILS_FAILED";
export const UPDATE_OTHER_DIRECT_COSTS_INIT = "UPDATE_OTHER_DIRECT_COSTS_INIT";
export const UPDATE_OTHER_DIRECT_COSTS_SUCCESS =
  "UPDATE_OTHER_DIRECT_COSTS_SUCCESS";
export const UPDATE_OTHER_DIRECT_COSTS_FAILED =
  "UPDATE_OTHER_DIRECT_COSTS_FAILED";
export const UPDATE_REVENUE_INIT = "UPDATE_REVENUE_INIT";
export const UPDATE_REVENUE_SUCCESS = "UPDATE_REVENUE_SUCCESS";
export const UPDATE_REVENUE_FAILED = "UPDATE_REVENUE_FAILED";
export const UPDATE_MARGIN_INIT = "UPDATE_MARGIN_INIT";
export const UPDATE_MARGIN_SUCCESS = "UPDATE_MARGIN_SUCCESS";
export const UPDATE_MARGIN_FAILED = "UPDATE_MARGIN_FAILED";
export const GET_DETAILED_VIEW_RATES_INIT = "GET_DETAILED_VIEW_RATES_INIT";
export const GET_DETAILED_VIEW_RATES_SUCCESS =
  "GET_DETAILED_VIEW_RATES_SUCCESS";
export const GET_DETAILED_VIEW_RATES_FAILED = "GET_DETAILED_VIEW_RATES_FAILED";
export const UPDATE_DETAILED_VIEW_RATES_INIT =
  "UPDATE_DETAILED_VIEW_RATES_INIT";
export const UPDATE_DETAILED_VIEW_RATES_SUCCESS =
  "UPDATE_DETAILED_VIEW_RATES_SUCCESS";
export const UPDATE_DETAILED_VIEW_RATES_FAILED =
  "UPDATE_DETAILED_VIEW_RATES_FAILED";
export const GET_CONTRACT_YEARS_INIT = "GET_CONTRACT_YEARS_INIT";
export const GET_CONTRACT_YEARS_SUCCESS = "GET_CONTRACT_YEARS_SUCCESS";
export const GET_CONTRACT_YEARS_FAILED = "GET_CONTRACT_YEARS_FAILED";
export const GET_CONTRACTS_INIT = "GET_CONTRACTS_INIT";
export const GET_CONTRACTS_SUCCESS = "GET_CONTRACTS_SUCCESS";
export const GET_CONTRACTS_FAILED = "GET_CONTRACTS_FAILED";
export const DOWNLOAD_DETAILED_VIEW_INIT = "DOWNLOAD_DETAILED_VIEW_INIT";
export const DOWNLOAD_DETAILED_VIEW_SUCCESS = "DOWNLOAD_DETAILED_VIEW_SUCCESS";
export const DOWNLOAD_DETAILED_VIEW_FAILED = "DOWNLOAD_DETAILED_VIEW_FAILED";
export const DOWNLOAD_PSR_INIT = "DOWNLOAD_PSR_INIT";
export const DOWNLOAD_PSR_SUCCESS = "DOWNLOAD_PSR_SUCCESS";
export const DOWNLOAD_PSR_FAILED = "DOWNLOAD_PSR_FAILED";
export const GET_FINANCIAL_YEAR_SETTINGS_INIT =
  "GET_FINANCIAL_YEAR_SETTINGS_INIT";
export const GET_FINANCIAL_YEAR_SETTINGS_SUCCESS =
  "GET_FINANCIAL_YEAR_SETTINGS_SUCCESS";
export const GET_FINANCIAL_YEAR_SETTINGS_FAILED =
  "GET_FINANCIAL_YEAR_SETTINGS_FAILED";
export const GET_FINANCIAL_YEARS_INIT = "GET_FINANCIAL_YEARS_INIT";
export const GET_FINANCIAL_YEARS_SUCCESS = "GET_FINANCIAL_YEARS_SUCCESS";
export const GET_FINANCIAL_YEARS_FAILED = "GET_FINANCIAL_YEARS_FAILED";
export const CREATE_FINANCIAL_YEARS_INIT = "CREATE_FINANCIAL_YEARS_INIT";
export const CREATE_FINANCIAL_YEARS_SUCCESS = "CREATE_FINANCIAL_YEARS_SUCCESS";
export const CREATE_FINANCIAL_YEARS_FAILED = "CREATE_FINANCIAL_YEARS_FAILED";
export const GET_VERSIONS_INIT = "GET_VERSIONS_INIT";
export const GET_VERSIONS_SUCCESS = "GET_VERSIONS_SUCCESS";
export const GET_VERSIONS_FAILED = "GET_VERSIONS_FAILED";
export const GET_DETAILED_VIEW_HEADERS_INIT = "GET_DETAILED_VIEW_HEADERS_INIT";
export const GET_DETAILED_VIEW_HEADERS_SUCCESS =
  "GET_DETAILED_VIEW_HEADERS_SUCCESS";
export const GET_DETAILED_VIEW_HEADERS_FAILED =
  "GET_DETAILED_VIEW_HEADERS_FAILED";
export const OPPORTUNITY_YEARS_LIST_INIT = "OPPORTUNITY_YEARS_LIST_INIT";
export const OPPORTUNITY_YEARS_LIST_SUCCESS = "OPPORTUNITY_YEARS_LIST_SUCCESS";
export const SELECTED_OPP_YEAR_INIT = "SELECTED_OPP_YEAR_INIT";
export const SELECTED_OPP_YEAR_SUCCESS = "SELECTED_OPP_YEAR_SUCCESS";
